<template>
  <v-card
    :width="width"
    :height="height"
  >
    <div style="height: 50px" class="d-flex flex-no-wrap align-end">
      <slot name="header">
        <div class="px-2">
          <span class="font-weight-light">{{firstDataLabel}}</span>
          <span 
            class="text-h5 ml-2" 
            :class="{
              'success--text': firstDataPositive, 
              'error--text': !firstDataPositive
            }"
          >{{firstData}}</span>
          <v-icon 
            small 
            class="mb-1 ml-1" 
            :color="firstDataPositive ? 'success' : 'error'"
            v-if="firstData"
          >
            {{firstDataPositive ? 'mdi-chevron-up' : 'mdi-chevron-down'}}
          </v-icon>
        </div>
        <div class="px-2">
          <span class="font-weight-light">{{secondDataLabel}}</span>
          <span 
            class="text-h5 ml-2" 
            :class="{
              'success--text': secondDataPositive, 
              'error--text': !secondDataPositive
            }"
          >{{secondData}}</span>
          <v-icon 
            small 
            class="mb-1 ml-1" 
            :color="secondDataPositive ? 'success' : 'error'"
            v-if="secondData"
          >
            {{secondDataPositive ? 'mdi-chevron-up' : 'mdi-chevron-down'}}
          </v-icon>
        </div>
        <div class="ml-auto pr-2">
          <v-btn icon small><v-icon small>mdi-pin</v-icon></v-btn>
        </div>
      </slot>
    </div>
    <div class="chart-wrapper">
      <LineChartBase
        :chart-data="chartData"
        :styles="computedStyles"
        :options="chartOptions"
      ></LineChartBase>
    </div>
    <div style="height: 70px" class="px-2 d-flex align-center justify-end">
      <v-select
        :items="periodOptions"
        v-model="selected"
        filled
        dense
        hide-details="auto"
        style="max-width: 40%"
      ></v-select>
    </div>
  </v-card>
</template>

<script>
import LineChartBase from './LineChartBase.vue'

export default {
  name: "LineChart",
  components: { LineChartBase },
  data: function() {
    return {
      periodOptions: [
        'Ultimi 7 giorni',
        'Ultimo Mese',
        'Ultimo Trimestre',
        'Ultimo Anno',
      ],
      selected: undefined
    }
  },
  mounted: function() {
    this.selected = this.periodOptions[0]
  },
  props: {
    maintainAspectRatio: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: "400px"
    },
    width: {
      type: String,
      default: "600px"
    },
    chartData: {
      type: Object,
      default: function() {
        return {
          datasets: []
        }
      }
    },
    firstDataLabel: {
      type: String,
      default: undefined
    },
    firstData: {
      type: String,
      default: undefined
    },
    firstDataPositive: {
      type: Boolean,
      default: true
    },
    secondDataLabel: {
      type: String,
      default: undefined
    },
    secondData: {
      type: String,
      default: undefined
    },
    secondDataPositive: {
      type: Boolean,
      default: true
    },
    styles: {
      type: Object,
      default: function() {
        return { }
      }
    }
  },
  computed: {
    chartOptions() {
      return {
        maintainAspectRatio: this.maintainAspectRatio,
        responsive: this.responsive,
      }
    },
    computedStyles() {
      return {
        ...this.styles,
        height: "calc(" + this.height + " - 120px)",
        // width: this.width,
        'max-width': this.maxWidth
      }
    }
  }
}
</script>

<style>

</style>